(function(){
 var m=document.querySelector('[data-menu]'),n=document.querySelector('[data-nav]');
 if(m&&n)m.addEventListener('click',function(){var o=n.classList.toggle('open');m.setAttribute('aria-expanded',o)});
 document.querySelectorAll('[data-copy]').forEach(function(b){b.addEventListener('click',function(){
  var s=b.querySelector('span'),t=s.textContent;
  (navigator.clipboard?navigator.clipboard.writeText(b.dataset.copy):Promise.resolve()).then(function(){s.textContent='Copied';setTimeout(function(){s.textContent=t},1600)});
 })});
 var v=document.querySelector('[data-variant]');
 if(v)v.addEventListener('change',function(){
  var o=v.options[v.selectedIndex],p=document.querySelector('[data-price]'),c=document.querySelector('[data-compare]');
  var s=document.querySelector('[data-save]');p.textContent=o.dataset.price;c.textContent=o.dataset.compare;c.hidden=!o.dataset.compare;if(s){s.textContent='Save '+o.dataset.pct+'%';s.hidden=!o.dataset.pct;}
 });
 var big=document.querySelector('[data-main] img');
 document.querySelectorAll('.thumbs button').forEach(function(b){b.addEventListener('click',function(){if(big){big.removeAttribute('srcset');big.src=b.dataset.src}})});
var t=document.querySelector('[data-search-toggle]'),sp=document.querySelector('[data-search-panel]');
 if(t&&sp){
  var close=function(){sp.hidden=true;t.setAttribute('aria-expanded','false')};
  t.addEventListener('click',function(){var o=sp.hidden;sp.hidden=!o;t.setAttribute('aria-expanded',o);if(o)sp.querySelector('input[type=search]').focus()});
  document.addEventListener('keydown',function(e){if(e.key==='Escape')close()});
 }
})();
